// extracted by mini-css-extract-plugin
export default {"title":"style_title__MwDYy","prodoctsList":"style_prodoctsList__uNkaA"};